"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNavigatorPermission = void 0;

var React = __importStar(require("react"));

var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var utils_2 = require("./utils");

function useNavigatorPermissionClient(permDesc) {
  var _a = React.useState(''),
      state = _a[0],
      setState = _a[1];

  React.useEffect(function () {
    if (utils_1.isBrowser) {
      var mounted_1 = true;
      var permissionStatus_1 = null;

      var onChange_1 = function onChange_1() {
        if (mounted_1 && permissionStatus_1 !== null) {
          setState(permissionStatus_1.state);
        }
      };

      var changeState_1 = function changeState_1() {
        onChange_1();
        utils_2.on(permissionStatus_1, 'change', onChange_1);
      };

      navigator.permissions.query(permDesc).then(function (status) {
        permissionStatus_1 = status;
        changeState_1();
      }).catch(utils_1.noop);
      return function cleanup() {
        mounted_1 = false;

        if (permissionStatus_1 !== null) {
          utils_2.off(permissionStatus_1, 'change', onChange_1);
        }
      };
    }
  }, []);
  return state;
}

var useNavigatorPermissionMock = function useNavigatorPermissionMock() {
  return '';
};

exports.useNavigatorPermission = utils_1.isBrowser && typeof navigator === 'object' && !navigator.permissions ? useNavigatorPermissionClient : useNavigatorPermissionMock;